var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91668 0.75V1.44444H0.444458V2.83333H1.1389V11.8611C1.1389 12.2295 1.28523 12.5827 1.5457 12.8432C1.80617 13.1037 2.15944 13.25 2.52779 13.25H9.47224C9.84059 13.25 10.1939 13.1037 10.4543 12.8432C10.7148 12.5827 10.8611 12.2295 10.8611 11.8611V2.83333H11.5556V1.44444H8.08335V0.75H3.91668ZM2.52779 2.83333H9.47224V11.8611H2.52779V2.83333ZM3.91668 4.22222V10.4722H5.30557V4.22222H3.91668ZM6.69446 4.22222V10.4722H8.08335V4.22222H6.69446Z",
    fill: "#21AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2287bb9d3542b17664d2bc82797c6d71.svg";
export { ForwardRef as ReactComponent };